
import {
    Component,
    ChangeDetectionStrategy,
    Type
} from '@angular/core';
import {
    FieldTypeConfig,
    FormlyFieldConfig,
    FieldType,
    FormlyFieldProps
} from '@ngx-formly/core';

interface TextAreaProps extends FormlyFieldProps {
    cols?: number;
    rows?: number;
    allowResize?: boolean;
}

export interface FormlyTextAreaFieldConfig extends FormlyFieldConfig<TextAreaProps> {
    type: 'textarea' | Type<FormlyFieldTextArea>;
}

@Component({
  standalone: false,
    selector: "formly-field-textarea",
    templateUrl: "./textarea.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldTextArea extends FieldType<FieldTypeConfig<TextAreaProps>> {
    override defaultOptions = {
        props: {
            cols: 1,
            rows: 1,
            allowResize: false,
        },
    };
}